import React, { useState } from 'react';
import Icons from "../../../components/Icons";
import { useTranslation } from 'react-i18next';

const Sidebar = (props) => {
  const path = props.location.pathname;
  const { t, i18n } = useTranslation();
  const [ lang, setLang ] = useState(localStorage.getItem('language') || 'id');
  const [ nav, setNav ] = useState({
    couriers:false,
    pricing:false,
    maps:false
  });

  const onClickNav = (type) => {
    if (nav[type]) {
      setNav({...nav, [type]: false})
    } else {
      setNav({...nav, [type]: true})
    }
  };

  const onLanguageHandle = (event) => {
    let newLang = event.target.value;
    localStorage.setItem('language', newLang);
    setLang(newLang)
    i18n.changeLanguage(newLang)
  }

  return (
    <nav className="col-3 d-md-block sidebar-docs border border-right border-bottom-0 border-top-0">
      <div className='sidebar-sticky'>
        <h4>
          <a href="/">
            <strong className="text-primary">Biteship</strong> API
          </a>
        </h4>

        <ul className="nav flex-column">
          <li className="nav-item mb-2">
            <a href="/docs/api" className={`nav-link pl-0 ${path === '/docs/api' || path === '/docs/api/introduction' ? 'active':'' }`}>
              Introduction
            </a>
          </li>
          <li className="nav-item mb-2">
            <a href="/docs/api/authentication" className={`nav-link pl-0 ${path === '/docs/api/authentication' ?  'active':'' }`}>
              Authentication
            </a>
          </li>
          <li className="nav-item mb-2">
            <a href="/docs/api/errors" className={`nav-link pl-0 ${path === '/docs/api/errors' ?  'active':'' }`}>
              Errors
            </a>
          </li>
          <br/>
          <b className="mb-2">Maps</b>
          <li onClick={() => onClickNav('maps')} className="nav-item mb-2 navbar-group">
            <a href="/docs/api/maps" className={`nav-link pl-0 ${path === '/docs/api/maps' ?  'active':'' }`}>
              Area <Icons name={path === '/docs/api/maps' ||
            path === '/docs/api/maps' ||
            path === '/docs/api/maps/area' ?  'FiChevronUp':'FiChevronDown' } style={{marginLeft:24}}/>
            </a>
          </li>
          <ul className={`nav flex-column navbar-group-content ${
              nav.couriers ||
              path === '/docs/api/maps' ||
              path === '/docs/api/maps/single_search_area' ||
              path === '/docs/api/maps/double_search_area' ? '' : 'display-none'}`}>
            <li className="nav-item mb-2">
              <a href="/docs/api/maps/single_search_area" className={`nav-link pl-0 ${path === '/docs/api/maps/single_search_area' ?  'active':'' }`}>
                Single Search Area
              </a>
            </li>
            <li className="nav-item mb-2">
              <a href="/docs/api/maps/double_search_area" className={`nav-link pl-0 ${path === '/docs/api/maps/double_search_area' ?  'active':'' }`}>
                Double Search Area
              </a>
            </li>
          </ul>
          <br/>
          <b className="mb-2">Main API</b>
          <li onClick={() => onClickNav('couriers')} className="nav-item mb-2 navbar-group">
            <a href="/docs/api/couriers" className={`nav-link pl-0 ${path === '/docs/api/couriers' ?  'active':'' }`}>
              Couriers <Icons name={path === '/docs/api/couriers' ||
            path === '/docs/api/couriers' ||
            path === '/docs/api/couriers/list' ?  'FiChevronUp':'FiChevronDown' } style={{marginLeft:24}}/>
            </a>
          </li>
          <ul className={`nav flex-column navbar-group-content ${
            nav.couriers ||
            path === '/docs/api/couriers' ||    
            path === '/docs/api/couriers/list' ? '' : 'display-none'}`}>
            <li className="nav-item mb-2">
              <a href="/docs/api/couriers/list" className={`nav-link pl-0 ${path === '/docs/api/couriers/list' ?  'active':'' }`}>
                List all couriers
              </a>
            </li>
          </ul>
          <li onClick={() => onClickNav('pricing')} className="nav-item mb-2 navbar-group">
            <a href="/docs/api/rates" className={`nav-link pl-0 ${path === '/docs/api/rates' ?  'active':'' }`}>
              Rates <Icons name={path === '/docs/api/rates' ||
            path === '/docs/api/rates/couriers_coordinate' ||
            path === '/docs/api/rates/couriers_postal_code' ||
            path === '/docs/api/rates/couriers_area_id' ||
            path === '/docs/api/rates/couriers_mix'?  'FiChevronUp':'FiChevronDown' } style={{marginLeft:24}}/>
            </a>
          </li>
          <ul className={`nav flex-column navbar-group-content ${
            nav.pricing ||
            path === '/docs/api/rates' ||
            path === '/docs/api/rates/couriers_coordinate' ||
            path === '/docs/api/rates/couriers_postal_code' ||
            path === '/docs/api/rates/couriers_area_id' ||
            path === '/docs/api/rates/couriers_mix' ? '' : 'display-none'}`}>
            <li className="nav-item mb-2">
              <a href="/docs/api/rates/couriers_coordinate" className={`nav-link pl-0 ${path === '/docs/api/rates/couriers_coordinate' ?  'active':'' }`}>
                Retrieve courier rates by coordinate
              </a>
            </li>
            <li className="nav-item mb-2">
              <a href="/docs/api/rates/couriers_postal_code" className={`nav-link pl-0 ${path === '/docs/api/rates/couriers_postal_code' ?  'active':'' }`}>
                Retrieve courier rates by postal code
              </a>
            </li>
            <li className="nav-item mb-2">
              <a href="/docs/api/rates/couriers_area_id" className={`nav-link pl-0 ${path === '/docs/api/rates/couriers_postal_code' ?  'active':'' }`}>
                Retrieve courier rates by area id
              </a>
            </li>
            <li className="nav-item mb-2">
              <a href="/docs/api/rates/couriers_mix" className={`nav-link pl-0 ${path === '/docs/api/rates/couriers_both' ?  'active':'' }`}>
                Retrieve courier rates by mix
              </a>
            </li>
          </ul>
          <li onClick={() => onClickNav('orders')} className="nav-item mb-2 navbar-group">
            <a href="/docs/api/orders" className={`nav-link pl-0 ${path === '/docs/api/orders' ?  'active':'' }`}>
              Orders <Icons name={path === path === '/docs/api/orders' ?  'FiChevronUp':'FiChevronDown' } style={{marginLeft:24}}/>
            </a>
          </li>
        </ul>

        <div className="mt-5">
            <div className="form-check form-check-inline">
                <input
                    checked={lang === 'en'}
                    name="language"
                    class="form-check-input"
                    onChange={(e) => onLanguageHandle(e)}
                    value="en"
                    type="radio" />
                <label class="form-check-label">
                    English
                </label>
            </div>
            <div className="form-check form-check-inline">
                <input
                    name="language"
                    value="id"
                    checked={lang === 'id'}
                    type="radio"
                    className="form-check-input"
                    onChange={(e) => onLanguageHandle ( e )}/>
                <label className="form-check-label">
                    Bahasa
                </label>
            </div>
          </div>


      </div>

    </nav>
  )
};


export default Sidebar;
